import React from 'react';
import PropTypes from 'prop-types';
import s from '../CricketTeam/CricketTeam.scss';
import Link from '../../../../../components/Link/Link';
//import { Link } from '@material-ui/core';

const CricketTeam = props => {
  const {
    cricket_team = [],
    compTypeId = '',
    leagueId = '',
    parentId = '',
    pageUrl = '',
  } =
    props.sectionItem || {};
  return (
    <>
      {cricket_team &&
        Array.isArray(cricket_team) &&
        cricket_team.length > 0 && (
          <div className={s.team_page}>
            {cricket_team.map(item => {
              //  upcomingMatchData
              let upcomingMatchData =
                item &&
                item.matches &&
                Array.isArray(item.matches) &&
                item.matches.length > 0 &&
                item.matches.filter(
                  matchItem => matchItem && matchItem.outcome === '',
                );
              upcomingMatchData =
                Array.isArray(upcomingMatchData) && upcomingMatchData.length > 0
                  ? upcomingMatchData[0]
                  : [];
              // rankingData
              const rankingData =
                item &&
                item.ranking &&
                Array.isArray(item.ranking) &&
                item.ranking.length > 0 &&
                item.ranking.filter(
                  data =>
                    data.comp_type_id === compTypeId &&
                    data.league_id === leagueId,
                )[0];

              // trophyData
              const trophyData =
                item &&
                item.trophy_details &&
                Array.isArray(item.trophy_details) &&
                item.trophy_details.length > 0 &&
                item.trophy_details.filter(
                  data => data.parent_id === parentId,
                )[0];
              const newTrophyArray = trophyData && trophyData.year.split(',');
              const trophyItem =
                newTrophyArray &&
                Array.isArray(newTrophyArray) &&
                newTrophyArray.map((itm, index) => (
                  <span key={index}>{itm.trim().slice(2)}</span>
                ));
              return (
                <Link
                  to={`${pageUrl}/${
                    item?.id
                  }/${item?.name.toLowerCase().replace(' ', '-')}`}
                  className={s.team_details_block}
                >
                  <div className={`${s.blue} `}>
                    <div className={s.top_header}>
                      <div className={s.top_header_bg} />
                      <div className={s.name_icon}>
                        <i className={`${s.icon} ${s[item.short_name]}`} />
                        {item?.name}
                      </div>

                      {rankingData && (
                        <div className={s.score_ranking}>
                          <div className={s.rank}>
                            {(rankingData && rankingData.ranking) || '-'}
                          </div>
                          <div className={s.rank_text}>
                            {' '}
                            {rankingData && rankingData?.comp_type} Ranking
                          </div>
                        </div>
                      )}
                    </div>
                    <div className={s.match_details}>
                      <div className={`${s.highest_finsih} ${s.row}`}>
                        <div className={s.text}>Winners In</div>
                        <div className={`${s.higest_result} ${s.winners}`}>
                          <span className={s.trophy}>
                            {trophyItem && <i />}
                          </span>
                          {trophyItem || '-'}
                        </div>
                      </div>
                      <div className={`${s.upcoming_match} ${s.row}`}>
                        <div className={s.text}>Upcoming match</div>
                        <div className={s.upcoming_match_details}>
                          <div className={s.flag_name}>
                            <i
                              className={`${s.icon} ${
                                s[upcomingMatchData.vs_shortname]
                              }`}
                            />
                            {upcomingMatchData.vs_shortname || '-'}
                          </div>
                          <div className={s.date}>
                            {upcomingMatchData.date || '-'}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        )}
    </>
  );
};
CricketTeam.propTypes = {
  sectionItem: PropTypes.objectOf({}),
};
CricketTeam.defaultProps = {
  sectionItem: {},
};

export default React.memo(CricketTeam);
